import React from "react";
import PropTypes from "prop-types";
import { CalendarX2, Plus } from "lucide-react";

import { UIEmptyState } from "../ui";

const EmptyEventsState = ({ title, description, actionLabel, onCreate }) => (
  <UIEmptyState
    title={title}
    description={description}
    icon={<CalendarX2 />}
    actionLabel={actionLabel}
    actionIcon={actionLabel ? <Plus /> : null}
    onAction={onCreate}
  />
);

EmptyEventsState.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  actionLabel: PropTypes.string,
  onCreate: PropTypes.func,
};

EmptyEventsState.defaultProps = {
  actionLabel: undefined,
  onCreate: undefined,
};

export default EmptyEventsState;
